/* eslint-disable react/prop-types */
import { Box, Button, Divider, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import ConditionsAccordion from "../../../Components/AdminComponents/EditSecurityModel/subComponent/ConditionsTable";
import SecurityCityBox from "../../../Components/AdminComponents/EditSecurityModel/subComponent/SecurityCityBox";
import RenderTag from "../../../Components/Common/RenderTag";

const TribalView = ({ tribes }) => {
  const [selectedTribe, setSelectedTribe] = useState(null);
  const [initialTribe, setInitialTribe] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);

  const options = tribes.map((tribe) => ({
    value: tribe.TribeName,
    label: tribe.TribeName,
  }));

  useEffect(() => {
    if (tribes.length > 0) {
      const firstTribe = tribes[0];
      setSelectedTribe(firstTribe);
      setInitialTribe(firstTribe);
      setSelectedOption({
        value: firstTribe.TribeName,
        label: firstTribe.TribeName,
      });
    }
  }, [tribes]);

  const handleChange = (selectedOption) => {
    const selected = tribes.find(
      (tribe) => tribe.TribeName === selectedOption.value
    );

    setSelectedTribe(selected);
    setSelectedOption(selectedOption);
  };

  const handleConditionsChange = (updatedConditions) => {
    setSelectedTribe((prevTribe) => ({
      ...prevTribe,
      Conditions: updatedConditions.map((condition) => ({
        Field: condition.Field,
        Operator: condition.Operator,
        Value: condition.Value,
        Reference: condition.Reference || "",
        Order: condition.Order || "base",
      })),
    }));
  };

  const handleAddCity = (newCity) => {
    setSelectedTribe((prevTribe) => ({
      ...prevTribe,
      CITY: [...prevTribe.CITY, newCity],
    }));
  };

  const handleAddZip = (zip) => {
    setSelectedTribe((prevTribe) => ({
      ...prevTribe,
      ZIP: [...prevTribe.ZIP, zip],
    }));
  };

  const handleAddCounties = (counties) => {
    setSelectedTribe((prevTribe) => ({
      ...prevTribe,
      COUNTY_DESC: [...prevTribe.COUNTY_DESC, counties],
    }));
  };

  const handleSaveChanges = () => {
    console.log("check what is saving.....", selectedTribe);
    toast.success("Data saved successfully");
  };

  const handleDiscard = () => {
    setSelectedTribe(initialTribe);
    setSelectedOption({
      value: initialTribe.TribeName,
      label: initialTribe.TribeName,
    });
  };

  return (
    <Box w="100%" position="relative">
      {/* Fixed top-right buttons */}
      <Box
        position="fixed"
        top="22%"
        right={4}
        zIndex={1000}
        display="flex"
        gap={2}
      >
        <Button variant="primaryButton" onClick={handleSaveChanges}>
          Save
        </Button>
        <Button onClick={handleDiscard}>Discard</Button>
      </Box>

      {/* Scrollable content */}
      <Box mt={0} pt={0}>
        <Box
          display="flex"
          alignItems={{ base: "start", md: "center" }}
          justifyContent="space-between"
          flexDir={{ base: "column-reverse", md: "row" }}
        >
          <Box w={{ base: "100%", md: "350px" }}>
            <Text fontWeight="bold" mb={1}>
              Select a Tribe:
            </Text>
            <Select
              options={options}
              value={selectedOption}
              onChange={handleChange}
              placeholder="Choose a Tribe"
              styles={{
                control: (base) => ({
                  ...base,
                  borderColor: "#CBD5E0",
                  boxShadow: "none",
                  "&:hover": { borderColor: "#3182CE" },
                  width: "100%",
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected ? "#3c1514" : "white",
                  color: state.isSelected ? "white" : "black",
                  "&:hover": {
                    backgroundColor: "#fde9e8",
                    color: "black",
                  },
                }),
                menu: (base) => ({
                  ...base,
                  width: "100%",
                }),
              }}
            />
          </Box>
        </Box>

        {selectedTribe && (
          <Box mt={4} p={2}>
            <Divider />
            <Box display="flex" gap={7} mb={5}>
              <RenderTag
                data={selectedTribe?.ZIP}
                title="ZIP"
                width="60%"
                onAdd={handleAddZip}
              />
              <RenderTag
                data={selectedTribe?.COUNTY_DESC}
                title="COUNTIES"
                width="40%"
                onAdd={handleAddCounties}
              />
            </Box>
            <SecurityCityBox
              tribe={selectedTribe}
              onDeleteCity={(index) => {
                const updatedCities = selectedTribe.CITY.filter(
                  (_, idx) => idx !== index
                );
                setSelectedTribe({ ...selectedTribe, CITY: updatedCities });
              }}
              onAddCity={handleAddCity}
            />
            <ConditionsAccordion
              initialData={selectedTribe?.Conditions || []}
              onConditionsChange={handleConditionsChange}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default TribalView;
